import { ensureAncillaryContentSubtype } from "../../../../../../common/types/AncillaryContentType";
import { ContentSubtype } from "../../../../../../common/types/ContentSubtype";
import { ensureMovieContentSubtype } from "../../../../../../common/types/MovieContentSubtype";
import {
    getCloudMovieDetailsHref,
    getCloudTvSeriesDetailsHref,
    getCloudAncillaryDetailsHref
} from "../../../../../AssetsRoutes";

export const resolveCloudAssetHref = (contentType: ContentSubtype, newAssetId: string): string => {
    switch (contentType) {
        case ContentSubtype.Movie:
        case ContentSubtype.TvSingle:
        case ContentSubtype.FeatureDocumentary:
        case ContentSubtype.ShortFilm:
            ensureMovieContentSubtype(contentType);
            return getCloudMovieDetailsHref(newAssetId, contentType);
        case ContentSubtype.TV:
            return getCloudTvSeriesDetailsHref(newAssetId);
        case ContentSubtype.Advert:
        case ContentSubtype.Promo:
        case ContentSubtype.Safety:
        case ContentSubtype.IndentWarning:
        case ContentSubtype.ClientSpecific:
            ensureAncillaryContentSubtype(contentType);
            return getCloudAncillaryDetailsHref(newAssetId, contentType);
        default:
            return "";
    }
};
